import React from 'react';

import {
  ClientContactTag,
  ContactType,
  SupplierContactTag,
} from '@bb/contacts';

import TagGroup, { TagGroupOption, TagGroupProps } from '../TagGroup';

export type ContactTagType = ClientContactTag | SupplierContactTag;

export const CLIENT_CONTACT_TAGS: Record<
  ClientContactTag,
  TagGroupOption<ClientContactTag>
> = {
  [ClientContactTag.Buyer]: {
    value: ClientContactTag.Buyer,
    label: 'Buyer',
  },
  [ClientContactTag.Landlord]: {
    value: ClientContactTag.Landlord,
    label: 'Landlord / Manager',
  },
  [ClientContactTag.Seller]: {
    value: ClientContactTag.Seller,
    label: 'Seller',
  },
  [ClientContactTag.Tenant]: {
    value: ClientContactTag.Tenant,
    label: 'Tenant',
  },
};

export const SUPPLIER_CONTACT_TAGS: Record<
  SupplierContactTag,
  TagGroupOption<SupplierContactTag>
> = {
  [SupplierContactTag.Appraiser]: {
    label: 'Appraiser',
    value: SupplierContactTag.Appraiser,
  },
  [SupplierContactTag.Contractor]: {
    label: 'Contractor',
    value: SupplierContactTag.Contractor,
  },
  [SupplierContactTag.Stager]: {
    label: 'Designer / Stager',
    value: SupplierContactTag.Stager,
  },
  [SupplierContactTag.Graphic]: {
    label: 'Graphic Designer',
    value: SupplierContactTag.Graphic,
  },
  [SupplierContactTag.Inspector]: {
    label: 'Home Inspector',
    value: SupplierContactTag.Inspector,
  },
  [SupplierContactTag.Lawyer]: {
    label: 'Lawyer',
    value: SupplierContactTag.Lawyer,
  },
  [SupplierContactTag.Marketing]: {
    label: 'Marketing',
    value: SupplierContactTag.Marketing,
  },
  [SupplierContactTag.MortgageBroker]: {
    label: 'Mortgage Broker',
    value: SupplierContactTag.MortgageBroker,
  },
  [SupplierContactTag.Photo]: {
    label: 'Photographer',
    value: SupplierContactTag.Photo,
  },
  [SupplierContactTag.FloorPlans]: {
    label: 'Floor Plans',
    value: SupplierContactTag.FloorPlans,
  },
  [SupplierContactTag.Other]: {
    label: 'Other',
    value: SupplierContactTag.Other,
  },
};

export const CONTACT_TAGS = {
  [ContactType.Client]: CLIENT_CONTACT_TAGS,
  [ContactType.Supplier]: SUPPLIER_CONTACT_TAGS,
};

export const ALL_CONTACT_TAGS = {
  ...CLIENT_CONTACT_TAGS,
  ...SUPPLIER_CONTACT_TAGS,
};

interface ContactTypeTagsProps extends Omit<TagGroupProps, 'options'> {
  type: ContactType;
}

const ContactTypeTags: React.FC<ContactTypeTagsProps> = ({
  type,
  ...props
}) => (
    <TagGroup
      options={Object.values(CONTACT_TAGS[type])}
      closeButtonColor="gray8"
      tagProps={{ color: 'default' }}
      {...props}
    />
  );

export default ContactTypeTags;
